import { html, TemplateResult } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import componentStyles from './idb-label-data-heading.css.lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { SlotController } from '../../controllers/slot-controller';

/**
 * This component have 2 options, use values as slot which is the default or use properties.
 * as slot, label and data use a block container, but as properties, they use an inline container.
 */

/**
 * The IDB Image Card component.
 * @element idb-content-card
 * @extends OutlineElement
 * @slot heading-label - The heading label slot.
 * @slot heading-data - The heading data slot.
 */

@customElement('idb-label-data-heading')
export class LabelAndDataHeading extends OutlineElement {
  static styles = [componentStyles];

  @property({ type: String, attribute: 'label' })
  label: string;

  @property({ type: String, attribute: 'data' })
  data: string;

  /**
   * A boolean property that determines if use properties or not.
   * @type {boolean}
   * @attribute use-properties
   */
  @property({ type: Boolean, attribute: 'use-properties' })
  useProperties: false;

  @property({ type: String, attribute: 'classes' })
  classes: string;

  @state() hasHeadinglabel: boolean;
  @state() hasHeadingData: boolean;

  slots = new SlotController(
    this, // This, the host element.
    false // To shift or not to shift LightDom nodes to ShadowDOM.
  );

  firstUpdated(): void {
    this.hasHeadinglabel = this.slots.test('heading-label');
    this.hasHeadingData = this.slots.test('heading-data');
  }

  render(): TemplateResult {
    return this.useProperties
      ? this.oneColumnContainer()
      : this.twoColumnsContainer();
  }

  oneColumnContainer(): TemplateResult {
    return html`<section class=${`idb-label-data-heading-inline ${this.classes}`}>
      ${
        this.label
          ? html`
        <span class="heading-label">
          ${this.label}
          ${
            this.data
              ? html`
            <span class="colon">:&nbsp;</span>
          `
              : null
          }</span>`
          : null
      }
      ${
        this.data
          ? html`
        <span class="heading-data">${this.data}</span>
      `
          : null
      }
    </section>`;
  }

  twoColumnsContainer(): TemplateResult {
    return html`
      <section class=${`idb-label-data-heading ${this.classes}`}>
      ${
        this.hasHeadinglabel
          ? html`
      <div class="heading-label">
        <slot name="heading-label"></slot>
        ${
          this.hasHeadingData
            ? html`
          <span class="colon">:&nbsp;</span>
          `
            : null
        }
      </div>
      `
          : null
      }
      ${
        this.hasHeadingData
          ? html`
      <div class="heading-data">
        <slot name="heading-data"></slot>
      </div>
      `
          : null
      }
     </section>
    `;
  }
}
